import {logout} from '@auth/store/auth.actions';
import {createReducer, on} from '@ngrx/store';
import {setAnalyticsDailyProgress} from './analytics.actions';
import {DailyProgressDto} from '@shared/dto';

export const ANALYTICS_FEATURE_KEY = 'analytics';

export interface AnalyticsState {
  dailyProgress: DailyProgressDto | null;
}

export const initialState: AnalyticsState = {
  dailyProgress: null,
}

export const analyticsReducer = createReducer(
  initialState,
  on(setAnalyticsDailyProgress, (state, payload) => ({...state, dailyProgress: payload.dailyProgress})),
  on(logout, (state) => ({...initialState })),
);
